import { render, staticRenderFns } from "./ProgramCards.vue?vue&type=template&id=852bf6e8&"
import script from "./ProgramCards.vue?vue&type=script&lang=js&"
export * from "./ProgramCards.vue?vue&type=script&lang=js&"
import style0 from "./ProgramCards.vue?vue&type=style&index=0&id=852bf6e8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports